// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-container[data-v-205cbde1] {\r\n\r\n    display: flex;\r\n\r\n    width: 83.333333%;\r\n\r\n    flex-direction: column\n}\n.text-container p[data-v-205cbde1] {\r\n\r\n    padding-bottom: 1.25rem;\r\n\r\n    font-size: 0.875rem;\r\n\r\n    line-height: 1.75rem\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
